// apps/admin-ui/src/features/coin-transactions/api.ts
import { queryOptions } from '@tanstack/react-query';
import type { AdminCoinTransactionsResponse, CoinTxReason, CoinTxStatus } from '@upme/contracts';
import { api } from '../../app/api-client';

export const coinTransactionsKey = ['admin', 'coin-transactions'] as const;

// Filter-объект, нормализованный из URL search-params.
// Опциональные поля могут отсутствовать; в queryKey попадает «как есть»,
// поэтому ниже строим params с пропуском undefined/пустых массивов — иначе
// два эквивалентных вызова дадут разные ключи и кэш разойдётся.
export type CoinTransactionsListFilters = {
  cursor?: string;
  limit?: number;
  status?: CoinTxStatus[];
  reason?: CoinTxReason[];
  userId?: string;
};

function buildSearchParams(filters: CoinTransactionsListFilters): URLSearchParams {
  const p = new URLSearchParams();
  if (filters.cursor) p.set('cursor', filters.cursor);
  if (filters.limit !== undefined) p.set('limit', String(filters.limit));
  // Backend (libs/contracts AdminCoinTransactionsQuerySchema) ждёт массив; Nest
  // парсит `?status=PENDING&status=POSTED` в массив сам. Шлём repeated keys —
  // совместимо и с CSV-парсером на стороне controller'а (см. spec §5.2).
  if (filters.status?.length) {
    for (const s of filters.status) p.append('status', s);
  }
  if (filters.reason?.length) {
    for (const r of filters.reason) p.append('reason', r);
  }
  if (filters.userId) p.set('userId', filters.userId);
  return p;
}

export const listCoinTransactionsOptions = (filters: CoinTransactionsListFilters = {}) =>
  queryOptions({
    queryKey: [...coinTransactionsKey, 'list', filters] as const,
    queryFn: () =>
      api
        .get('admin/coins/transactions', { searchParams: buildSearchParams(filters) })
        .json<AdminCoinTransactionsResponse>(),
    staleTime: 5_000,
  });
